const profiles = {
  header: {
    btnCreate: 'Criar',
  },

  toast: {
    error: {
      badResponse: '[Perfil] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
      delete: {
        body: 'Os perfis foram excluídos com sucesso',
      },
    },
  },
  table: {
    headers: {
      name: 'Nome',
      email: 'E-mail',
      phone: 'Telefone',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  forms: {
    header: {
      createProfile: {
        title: 'Criar',
      },

      updateProfile: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    general: {
      header: 'Geral',
      fields: {
        profileType: {
          label: 'Tipo de Perfil',
          options: {
            retail: 'Varejo',
            individual: 'Pessoal',
            wholesale: 'Atacado',
            corporate: 'Corporativa',
            web: 'Web',
            hotel: 'Hotel',
            thirdParty: 'Terceiros',
            tourOperator: 'Operador de Viagem',
            receiptiveOperator: 'Operador Receptivo',
          },
        },
        rateType: {
          label: 'Tipo de Taxa',
          options: {
            connections: 'Conexões',
            corporate: 'Taxa Corporativa',
            expedia: 'Expedia',
            groundTransportation: 'Transporte Terrestre',
            holidayTaxis: 'Táxis de feriados',
            respectiveOperator: 'Respectiva Taxa do Operador',
            retail: 'Taxa real',
            tourOperator: 'Taxa de Operador de Viagem',
            viator: 'Viator',
          },
        },
        name: {
          label: 'Nome',
        },
        status: {
          label: 'Status',
          options: {
            active: 'Ativo',
            inactive: 'Inativa',
            onHold: 'Em espera',
          },
        },
        email: {
          label: 'Endereço de e-mail',
        },
        startDate: {
          label: 'Data de início',
        },
        phone: {
          label: 'Número de telefone',
        },
        additionalPhone: {
          label: 'Telefone adicional',
        },
        fax: {
          label: 'Número do fax',
        },
        attributes: {
          label: 'Atributos',
        },
      },
    },
    billing: {
      header: 'Informações de faturamento',
      fields: {
        name: {
          label: 'Nome para faturamento',
        },
        email: {
          label: 'Endereço de e-mail',
        },
        phone: {
          label: 'Número de telefone',
        },
        address: {
          label: 'Endereço',
        },
        city: {
          label: 'Cidade',
        },
        state: {
          label: 'Estado',
        },
        zip: {
          label: 'CEP',
        },
        country: {
          label: 'País',
          options: {
            usa: 'EUA',
          },
        },
      },
    },
    notes: {
      header: 'Observações',
      fields: {
        general: {
          label: 'Geral',
        },
        driver: {
          label: 'Motorista',
        },
        dispatch: {
          label: 'Despachar',
        },
      },
    },
    complexNotes: {
      header: 'Observações',
      fields: {
        type: {
          label: 'Tipo de nota',
          options: {
            accident: 'Acidente',
            complaint: 'Reclamação',
            agentIssue: '(CQ) Problema do agente',
            carIssue: '(CQ) Problema do veículo',
            noShow: 'No Show',
            general: 'Nota geral',
            disaptch: 'Aviso ao despacho',
            driver: 'Nota para o motorista',
            agent: 'Nota do Agente',
            cancel: 'Nota de Cancelamento',
            booking: 'Nota de Reserva',
          },
        },
        value: {
          label: 'Conteúdo da observação',
        },
      },
      add: 'Adicionar observação',
    },
    preferences: {
      header: 'Preferências',
      job: {
        header: 'Preferências de Reserva',
        fields: {
          service: {
            label: 'Serviço',
          },
          sharedWith: {
            label: 'Compartilhado com',
          },
        },
      },
      excludedDrivers: {
        header: 'Motoristas Excluídos',
        dualList: {
          driversList: {
            header: 'Lista de Motoristas',
          },
          excludedList: {
            header: 'Motoristas Excluídos',
          },
        },
      },
      excludedVehicles: {
        header: 'Veículos Excluídos',
        dualList: {
          vehiclesList: {
            header: 'Vehicle List',
          },
          excludedList: {
            header: 'Veículos Excluídos',
          },
        },
      },
    },
    jobHistory: {
      header: 'Histórico de reservas',
      lastJob: 'Última reserva: {{lastJob}}',
      firstJob: 'Primeira reserva: {{firstJob}}',
    },
    contacts: {
      header: 'Contatos',
      fields: {
        name: {
          label: 'Nome do contato',
        },
        type: {
          label: 'Tipo de contato',
          options: {
            sales: 'Vendedor',
            employee: 'Funcionário',
          },
        },
        email: {
          label: 'E-mail',
        },
        phone: {
          label: 'Número de telefone',
        },
        fax: {
          label: 'Número do fax',
        },
        address: {
          label: 'Endereço',
        },
        city: {
          label: 'Cidade',
        },
        state: {
          label: 'Estado',
        },
        zip: {
          label: 'CEP',
        },
        country: {
          label: 'País',
        },
        comment: {
          label: 'Comentário',
        },
      },
      add: 'Adicione contato',
    },
    rules: {
      header: 'Regras',
      fields: {
        value: 'Valor',
        discount: {
          label: 'Desconto',
          options: {
            none: 'Nenhum',
            fixed: 'Fixo',
            fixedPP: 'Fixo por passageiro',
            percent: 'Porcentagem',
            percentR: 'Porcentagem (arredondado)',
            percentRU: 'Porcentagem (arredondado para cima)',
          },
        },
        markup: {
          label: 'Remarcação',
          options: {
            none: 'Nenhum',
            fixed: 'Fixo',
            fixedPP: 'Fixo por passageiro',
            percent: 'Porcentagem',
            percentR: 'Porcentagem (arredondado)',
            percentRU: 'Porcentagem (arredondado para cima)',
          },
        },
      },
    },
    passengers: {
      header: 'Passageiros',
      found: '{{number}} passageiros encontrados',
      linkedTable: {
        title: 'Lista de Passageiros do Perfil',
        columns: {
          passenger: 'Passageiro',
          createdAt: 'Data de criação',
          vip: 'VIP',
          registerWith: 'Criado em',
          reservations: 'Reservas',
        },
        actions: {
          clear: 'Limpar filtro',
          remove: 'Remover passageiro',
        },
      },
      nonLinkedTable: {
        title: 'Lista de Passageiros Não Conectados',
        columns: {
          passenger: 'Passageiro',
          registerDate: 'Data de criação',
          registerWith: 'Criar em',
          profilesLinked: 'Perfis associados',
          reservations: 'Reservas',
        },
        actions: {
          clear: 'Limpar filtro',
          add: 'Conectar passageiro',
        },
      },
    },
  },
  update: {
    success: {
      content: 'As suas alterações foram salvas com sucesso.',
    },
    error: {
      content: 'Não foi possível salvar as alterações.',
    },
  },
  create: {
    success: {
      content: 'Seu Perfil foi Criado.',
    },
    error: {
      content: 'Não foi possível criar o perfil.',
    },
  },
  delete: {
    deleteBtn: 'Remover',
    deleteModal: {
      header: 'Excluir perfil?',
      body: 'Você está prestes a excluir os perfis {{number}}',
    },
  },
};

export default profiles;
